import { useEffect, useRef, useState } from 'react';

/**
 * useScrollReveal – Intersection Observer hook.
 * Returns { ref, inView } where `inView` is true once element enters viewport.
 * @param {{ threshold?: number; rootMargin?: string; once?: boolean }} options
 */
export default function useScrollReveal(options = {}) {
  const { threshold = 0.1, rootMargin = '0px 0px -60px 0px', once = true } = options;
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          if (once) observer.unobserve(el);
        } else if (!once) {
          setInView(false);
        }
      },
      { threshold, rootMargin }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [threshold, rootMargin, once]);

  return { ref, inView };
}
